/**
 * Safir custom conversion events (workstream 4).
 *
 * Every event is fanned out to whichever sinks exist, so connecting GA4 or
 * Meta later requires no theme changes:
 *  - window.dataLayer            (GTM / future tag manager)
 *  - window.gtag                 (GA4 gtag installs)
 *  - window.fbq trackCustom      (Meta pixel, once a pixel id is connected)
 *  - Shopify.analytics.publish   (Shopify custom pixels via customer events)
 *
 * Events:
 *  - safir_hiw_view              how-it-works strip entered the viewport (40%)
 *  - safir_hiw_passed_no_atc     shopper scrolled past the strip without any
 *                                add-to-cart click this page view
 *  - safir_creators_view         creator landing page viewed
 *  - safir_creators_form_start   first focus into the submission form
 *  - safir_creators_form_submit  submission form submitted
 *
 * Analytics must never break the store: everything is wrapped and passive.
 */
(function () {
  'use strict';

  function track(name, params) {
    var payload = params || {};
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, payload);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  function init() {
    // ------ how it works strip ------
    var hiw = document.querySelector('[data-safir-event="how-it-works"]');
    var atcClicked = false;
    var hiwSeen = false;
    var passedFired = false;

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (target && target.closest && target.closest('add-to-cart-component, [ref="addToCartButton"]')) {
          atcClicked = true;
        }
      },
      true
    );

    if (hiw) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting && !hiwSeen) {
                hiwSeen = true;
                track('safir_hiw_view');
                io.disconnect();
              }
            }
          },
          { threshold: 0.4 }
        );
        io.observe(hiw);
      }

      var checking = false;
      window.addEventListener(
        'scroll',
        function () {
          if (passedFired || checking) return;
          checking = true;
          window.requestAnimationFrame(function () {
            checking = false;
            if (passedFired) return;
            var rect = hiw.getBoundingClientRect();
            if (rect.bottom < 0 && !atcClicked) {
              passedFired = true;
              track('safir_hiw_passed_no_atc');
            }
          });
        },
        { passive: true }
      );
    }

    // ------ creator landing page ------
    var creators = document.querySelector('[data-safir-event="creators-page"]');
    if (creators) {
      track('safir_creators_view');

      var form = creators.querySelector('.safir-creators__form');
      if (form) {
        var started = false;
        form.addEventListener('focusin', function (event) {
          if (!started && event.target && event.target.matches && event.target.matches('input')) {
            started = true;
            track('safir_creators_form_start');
          }
        });
        form.addEventListener('submit', function () {
          track('safir_creators_form_submit');
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
